import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e) {
      setErr(e.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bg flex flex-col">
      <header className="px-4 md:px-6 h-16 flex items-center gap-4">
        <Link to="/" className="ab-logo shrink-0">AK</Link>
        <span className="label-overline">// Secure Terminal</span>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 pb-16">
        <form onSubmit={submit} className="w-full max-w-lg" data-testid="admin-login-form">
          <div className="mono text-[11px] uppercase tracking-[0.16em] text-ink-muted mb-5">
            // Authentication required
          </div>
          <h1 className="heavy text-5xl sm:text-6xl md:text-7xl leading-[0.9] mb-3">Admin<br />access.</h1>
          <p className="mono text-[12px] text-ink-muted mb-10">
            Ingest, classify, and curate the vault.
          </p>

          <div className="space-y-5">
            <div>
              <div className="label-overline mb-2">// Email</div>
              <input
                data-testid="admin-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@ak-archive.com"
                className="input-mono"
                required
              />
            </div>
            <div>
              <div className="label-overline mb-2">// Passcode</div>
              <input
                data-testid="admin-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="········"
                className="input-mono"
                required
              />
            </div>
          </div>

          {err && (
            <div className="mt-5 mono text-[11px] text-red-400" data-testid="admin-login-error">
              // ERR: {err}
            </div>
          )}

          <div className="mt-8 flex items-center gap-3">
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="pill pill-active"
            >
              {loading ? "Authenticating…" : "Enter vault →"}
            </button>
            <Link to="/" className="pill pill-sm">← Back</Link>
          </div>
        </form>
      </main>
    </div>
  );
}
